module.exports = "\r\n\r\n<input id=\"typeahead-config\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model\" [ngbTypeahead]=\"search\" />"